import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '@/store/authStore';
import { ROUTES } from '@/utils/constants';

const PublicRoute = () => {
  const { isAuthenticated } = useAuthStore();
  return isAuthenticated ? <Navigate to={ROUTES.DASHBOARD} replace /> : <Outlet />;
};

export default PublicRoute;
